import { useQuery, useQueryClient } from '@tanstack/react-query';
import { vulnerabilityService } from '@/services/vulnerabilityService';
import { queryKeys } from '@/lib/queryKeys';
import type { VulnerabilityOut } from '@/services/questionsService';

export function useVulnerabilitiesQuery(projectId: number | null) {
  return useQuery<VulnerabilityOut[]>({
    queryKey: queryKeys.vulnerabilities.all(projectId!),
    queryFn: () => vulnerabilityService.list(projectId!),
    enabled: !!projectId && !isNaN(projectId),
  });
}

export function useInvalidateVulnerabilities() {
  const queryClient = useQueryClient();
  return (projectId: number) =>
    queryClient.invalidateQueries({ queryKey: queryKeys.vulnerabilities.all(projectId) });
}
